import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  errorText: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#B30000",
  },
  calendar: {
    width: "100%",
    height: "32px",
    backgroundColor: "#ffffff",
    borderRadius: "0px",
    border: "1px solid !important",
    "& .k-selected": {
      borderWidth: "2px",
      borderStyle: "solid",
      borderColor: "rgb(0, 0, 0)",
      "& .k-link": {
        backgroundColor: "#17428b !important",
        "&:hover": {
          backgroundColor: "#00338D !important",
        },
      },
    },
    "& .k-calendar-title>.k-button-text": {
      color: "#3f51b5",
    },
    "&:focus": {
      border: "2px solid !important",
    },
    "& .k-calendar-nav-today>.k-button-text": {
      color: "#3f51b5",
      "&:hover": {
        color: "#3c4eae",
        border: "1px solid #3c4eae",
      },
    },
  },
}));
